import { useCommunityUserUIStore } from '@communities/community-user-layer/stores/community-user.ui-store'

import { useGroupsUIStore } from '../stores/groups.store'

/**
 * Clear Pinia fallbacks that can mask fresh user-group query data after leaving a group.
 */
export function resetCommunitiesMembershipUiAfterLeaveGroup(): void {
  try {
    useCommunityUserUIStore().setCurrentCommunityUser(null)
    const groupsUi = useGroupsUIStore()
    groupsUi.setGroupMembers([])
    groupsUi.setGroupAdmins([])
  } catch {
    // Pinia may be unavailable in some test harnesses
  }
}
